import React, { useEffect, useState } from "react";
import { adminApi } from "../../lib/api";
import { toast } from "sonner";
import { Mail, Check } from "lucide-react";

export default function AdminMessages() {
  const [messages, setMessages] = useState([]);
  const load = () => adminApi.get("/admin/messages").then((r) => setMessages(r.data));
  useEffect(() => { load(); }, []);

  const markRead = async (id) => {
    await adminApi.put(`/admin/messages/${id}`, { status: "leido" });
    toast.success("Marcado como leído");
    load();
  };

  return (
    <div>
      <h1 className="font-heading font-bold text-3xl tracking-tighter mb-6">Mensajes de contacto</h1>
      <div className="space-y-3">
        {messages.length === 0 && <p className="text-muted-foreground py-16 text-center">Sin mensajes.</p>}
        {messages.map((m) => (
          <div key={m.id} className={`border rounded-sm p-4 ${m.status === "nuevo" ? "border-brand/40 bg-brand/5" : "border-border bg-white"}`} data-testid={`message-${m.id}`}>
            <div className="flex items-center justify-between mb-1">
              <div className="flex items-center gap-2"><Mail className="h-4 w-4 text-brand" /><span className="font-medium">{m.name}</span>{m.company && <span className="text-xs text-muted-foreground">· {m.company}</span>}</div>
              {m.status === "nuevo" && <button onClick={() => markRead(m.id)} className="text-xs inline-flex items-center gap-1 text-emerald-700 hover:underline"><Check className="h-3 w-3" /> Marcar leído</button>}
            </div>
            <p className="text-sm text-muted-foreground mb-2">{m.email} · {m.phone}</p>
            <p className="text-sm">{m.message}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
